import Vue from 'vue';
import _ from 'lodash';
import Datepicker from 'vuejs-datepicker';
import { eventDate } from '@editor/droplets/cards-event/utils';

export default Vue.component('dynamic-input-date', {
  template: require('./template.html'),
  name: 'dynamic-input-date',
  components: {
    Datepicker,
  },
  props: [
    'active-item',
    'type',
    'value',
    'inner-tabs',
    'dynamic-tab',
    'open-cropper',
  ],
  data() {
    return {
      display: {},
      highlightDate: {
        dates: [new Date()],
      },
      dateFormat: 'D MMM dd, yyyy',
    };
  },
  watch: {
    innerTabs: {
      handler(tab) {
        if (tab[this.dynamicTab]) {
          this.setInitialValues();
        }
      },
      deep: true,
    },
  },
  methods: {
    setInitialValues() {
      const type = this.activeItem[this.type];
      const date = type && type.date ? type.date : new Date();
      this.$set(this.display, this.type, date);
    },
    closeDatePicker() {
      const picker = this.$refs.setPicker;
      if (!_.isUndefined(picker.clickOutside)) {
        picker.clickOutside(event);
      }
    },
    setDate(val) {
      const date = eventDate(val);
      this.$store.dispatch('setDropletVal', {
        drp: this.activeItem,
        key: this.type,
        val: date,
      });
    },
    startCase(text) {
      return _.startCase(text);
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/dynamic-data/edit-item/inputs/date-picker/index.js